import React from 'react'
import Typography from 'aldoo-ra/Typography'
import { UsersIcon } from '@heroicons/react/24/outline'

const AudiencePreview = ({
  audiencePreview,
  loadingPreview
}) => {
  return (
    <div className="bg-admin_paper border-t border-admin_bordered shadow-sm">
      <div className="px-4 py-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <UsersIcon className="w-4 h-4 text-admin_primary" />
            <Typography variant="admin_label" className="mb-0">
              Audience Reach
            </Typography>
            {loadingPreview && (
              <div className="h-3 w-3 animate-spin rounded-full border-b-2 border-admin_primary" />
            )}
          </div>

          <div className="flex items-center gap-2">
            <Typography variant="admin_txt2_dim" className="mb-0">
              Final Recipients:
            </Typography>
            <div className="text-2xl font-bold text-admin_primary">
              {(audiencePreview?.audienceSize || 0).toLocaleString()}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AudiencePreview
